import { trackingShape, withTracking } from "../../context";

type Props = {
  label: string;
  disabled?: boolean;
  onChange: $TSFixMeFunction;
  checked: boolean;
  filter: string;
  tracking: trackingShape;
};

export function SearchFilterItem({
  label,
  disabled,
  onChange,
  checked,
  filter,
  tracking,
}: Props) {
  const handleOnChange = (event: $TSFixMe) => {
    onChange(filter, event.target.checked);
    const eventProps = {
      filterItemName: label,
      actionType: event.target.checked ? "checked" : "unchecked",
    };
    tracking?.trackEvent("Search-Filter-Item-clicked", eventProps);
  };

  return (
    <li className="list-inline-item">
      <input
        id={`${label}-checkbox`}
        name={label}
        checked={checked}
        type="checkbox"
        disabled={disabled}
        onChange={handleOnChange}
      />
      <label htmlFor={`${label}-checkbox`}>{label}</label>
    </li>
  );
}
export default withTracking(SearchFilterItem);
